module.exports = __webpack_public_path__ + "static/media/dex-contact-pipelines.5fd6f5a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/dex-contact-pipelines.png
// module id = 193
// module chunks = 0